import store from '@/store'
import i18n from '@/lang'
import getField from '@/utils/getField'

export default function getLocalizedName (localizedName, locale) {
  if (localizedName && typeof localizedName === 'object') {
    if (locale && localizedName[locale]) {
      return localizedName[locale]
    }
    if (localizedName[i18n.global.locale]) {
      return localizedName[i18n.global.locale]
    }
    if (getField(localizedName[store.getters['user/getUserData']], 'defaultLocale')) {
      return localizedName[store.getters['user/getUserData'].defaultLocale]
    }
    if (localizedName.en) {
      return localizedName.en
    }
    const keys = Object.keys(localizedName)
    for (let i = 0; i < keys.length; i++) {
      if (localizedName[keys[i]]) {
        return localizedName[keys[i]]
      }
    }
  }
  return ''
}
